export default __webpack_public_path__ + "static/media/transfusion-medicine-1.1a292f15.jpg";